import { render, staticRenderFns } from "./ModalEditor.vue?vue&type=template&id=8b48aa3a&scoped=true&lang=pug&"
import script from "./ModalEditor.vue?vue&type=script&lang=js&"
export * from "./ModalEditor.vue?vue&type=script&lang=js&"
import style0 from "./ModalEditor.vue?vue&type=style&index=0&id=8b48aa3a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8b48aa3a",
  null
  
)

export default component.exports